class TokenNotProvidedError extends Error {
  constructor() {
    super('No Auth token has been provided');
  }
}

export default TokenNotProvidedError;
